import BaseClass from "../BaseClass";

export class CreatorRegistration extends BaseClass {
    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        this.initElements();
        this.initListeners();
        this.initForms();
        this.checkFormAvailability();
        this.switchToDefaultTab();

        this.backgroundTabSwitch = false;
        this.fileInputClicked = false;
        this.userInteractionInhibit = false;
    }

    initElements() {
        this.$tabControls = this.$element.find('[data-bs-toggle="tab"][data-bs-target]');
        this.$tabControlContainer = this.$tabControls.parents('.nav-tabs');

        this.$tabs = this.$tabControls.map(function () {
            const $tabControl = $(this);

            const bsTarget = $tabControl.data('bs-target');

            return $(bsTarget).get();
        });
    }

    initListeners() {
        $(document).on("user:interaction", $.proxy(this.onDocumentUserInteraction, this));
        $(document).on('content:loaded', $.proxy(this.onContentLoaded, this));
        $(document).on('visibilitychange', $.proxy(this.onDocumentVisibilityChange, this));
        $(window).on('beforeunload', $.proxy(this.onWindowBeforeUnload, this));

        this.$element.on('shown.bs.tab', $.proxy(this.onTabShown, this));
        this.$element.on('hide.bs.tab', $.proxy(this.onTabHide, this));
        this.$element.on('hidden.bs.tab', $.proxy(this.onTabHidden, this));

        this.$element.on('document_file_input:file:click', $.proxy(this.onDocumentFileClick, this));
        this.$element.on('document_file_input:done', $.proxy(this.onDocumentFileInputDone, this));

        $(document).on('state:recalculate', $.proxy(this.onStateRecalculate, this));
        $(document).on('step:next', $.proxy(this.onStepNext, this));

    }

    initForms() {
        this.$forms = this.$element.find('.tab-pane form');
        this.$lastForm = this.$forms.last();

        this.$socialForm = this.$element.find('#social-tab-pane form');
        this.$contactForm = this.$element.find('#contact-tab-pane form');
        this.$billingForm = this.$element.find('#billing-tab-pane form');
        this.$idShotForm = this.$element.find('#id-shot-tab-pane form');

        this.$lastForm.on('submit', $.proxy(this.onFinalSubmit, this));

        // Höhere priorität als FormHandler, damit mit stopImmediatePropagation abgebrochen werden kann.
        this.$lastForm.each(function () {
            const eventHandlers = $._data(this, 'events');
            const submitEventHandlers = eventHandlers['submit'];

            const lastSubmitEventHandler = submitEventHandlers.pop();

            submitEventHandlers.splice(0, 0, lastSubmitEventHandler);
        });
    }

    onContentLoaded() {
        this.initForms();
    }

    onDocumentVisibilityChange() {
        if (document.visibilityState == 'hidden') {
            if (!this.fileInputClicked) {
                this.sendActiveFormInBackground();
            }
        } else {
            this.fileInputClicked = false;
        }
    }

    onWindowBeforeUnload() {
        this.sendActiveFormInBackground();
    }

    onTabShown(event) {
        const $activeTabControl = $(event.target);
        // const $previousActiveTabControl = $(event.relatedTarget);

        $activeTabControl.parents('.nav-item:not(.selected)').addClass('selected');
        this.$tabControls.not($activeTabControl).parents('.nav-item.selected').removeClass('selected');
        this.fileInputClicked = false;
    }

    onTabHide(event) {
        const $activeTabControl = $(event.target);
        // const $toBeActiveTabControl = $(event.relatedTarget);

        if (!this.backgroundTabSwitch) {
            this.sendActiveFormInBackground($activeTabControl);
        }
    }

    onTabHidden(event) {
        const $previousActiveTabControl = $(event.target);
        // const $activeTabControl = $(event.relatedTarget);

        this.backgroundTabSwitch = false;
    }

    onStateRecalculate() {
        this.checkFormAvailability();
    }

    onStepNext() {
        this.switchToNextTab();
    }

    onFinalSubmit(event, data) {
        const self = this;

        this.fileInputClicked = false;

        let submitMode = 'background';
        if (data?.append?.submit !== undefined) {
            submitMode = data.append.submit;
        } else {
            if (event?.originalEvent?.submitter) {
                const $submitter = $(event.originalEvent.submitter);
                const submitValue = $submitter.val();
                if (submitValue !== undefined) {
                    submitMode = submitValue;
                }
            }
        }

        if (!['save', 'skip'].includes(submitMode)) {
            return;
        }

        this.$forms.not(this.$lastForm).each(function () {
            const $form = $(this);
            const valid = $form.data('valid');

            if (!valid) {
                // Wenn ein vorheriger Schritt noch nicht abgeschlossen ist hier abbrechen.
                event.stopImmediatePropagation();
                event.preventDefault();

                // Aktuelles Formular im Hintergrund speichern
                self.sendActiveFormInBackground();

                // Zu ungültigem Schritt wechseln.
                self.switchToFormTab($form);
                $form.trigger('submit', {append: {submit: 'save'}});
            }

            return valid; // Abbrechen beim ersten Formular das nicht valid ist.
        });
    }

    onDocumentUserInteraction() {
        if (!this.userInteractionInhibit) {
            this.fileInputClicked = false;
        }
    }

    onDocumentFileInputDone(event, data) {
        const $form = $(event.currentTarget);
        const $submitButton = $form.find('button[type="submit"]');

        $submitButton.prop('disabled', false);

        this.fileInputClicked = false;
    }

    onDocumentFileClick(event, data) {
        const self = this;
        this.fileInputClicked = true;
        this.userInteractionInhibit = true;

        window.setTimeout(function () {
            self.userInteractionInhibit = false;
        }, 1000)
    }

    sendActiveFormInBackground($activeTabControl) {
        if (typeof $activeTabControl == 'undefined') {
            $activeTabControl = this.$tabControls.filter('.active');
        }

        const target = $activeTabControl.data('bs-target');
        const $form = this.$tabs.filter(target).find('form');

        this.fileInputClicked = false;

        $form.trigger('submit', {append: {submit: 'background'}});
    }

    checkFormAvailability() {
        const socialValid = this.$socialForm.data('valid');
        const contactValid = this.$contactForm.data('valid');
        const billingValid = this.$billingForm.data('valid');
        const idShotValid = this.$idShotForm.data('valid');

        const socialEnabled = socialValid;
        let billingEnabled = socialValid;
        if (typeof contactValid == 'undefined') {
            billingEnabled = false;
        }
        let idShotEnabled = billingEnabled;
        if (typeof billingValid == 'undefined') {
            idShotEnabled = false;
        }

        this.$tabControls.filter('#contact-tab').prop('disabled', !socialEnabled);
        this.$tabControls.filter('#billing-tab').prop('disabled', !billingEnabled);
        this.$tabControls.filter('#id-shot-tab').prop('disabled', !idShotEnabled);

        const $activeNotDisabledTabControls = this.$tabControls.not(':disabled').filter('.active');

        if ($activeNotDisabledTabControls.length == 0) {
            this.switchToDefaultTab();
        }
    }

    switchToDefaultTab() {
        const self = this;

        this.fileInputClicked = false;

        this.$tabControls.not(':disabled')
            .filter(function () {
                const $tabControl = $(this);
                const target = $tabControl.data('bs-target');
                const $form = self.$tabs.filter(target).find('form');
                const valid = $form.data('valid');

                if (typeof valid == 'undefined') {
                    return true;
                }

                return !valid;
            })
            .first()
            .each(function () {
                const control = bootstrap.Tab.getOrCreateInstance(this);

                if (control !== undefined && control !== null) {
                    self.backgroundTabSwitch = true;

                    control.show();
                }
            });
    }

    switchToNextTab() {
        const self = this;
        const $possibleControls = this.$tabControls.not(':disabled');

        this.fileInputClicked = false;

        const $activeElement = $possibleControls.map(function (index) {
            const $element = $(this);

            return {
                index,
                active: $element.is('.active'),
            }
        }).filter(function () {
            return this.active;
        });

        const $nextControl = $activeElement.map(function () {
            const next = this.index + 1;
            const end = Math.min(next + 1, $possibleControls.length);

            let start = next;

            if (start == end) {
                start = Math.max(end - 1, 0);
            }

            start = Math.min(start, $possibleControls.length);

            return $possibleControls.slice(start, end).get();
        });

        if ($nextControl.length) {
            $nextControl.each(function () {
                const control = bootstrap.Tab.getOrCreateInstance(this);

                if (control !== undefined && control !== null) {
                    self.backgroundTabSwitch = true;

                    control.show();
                }
            });
        } else {
            this.switchToDefaultTab();

        }
    }

    switchToFormTab($form) {
        const self = this;
        const $tabs = this.$tabs;

        this.fileInputClicked = false;

        this.$tabControls.filter(function () {
            const $tabControl = $(this);
            const target = $tabControl.data('bs-target');
            const $tabForm = $tabs.filter(target).find('form');

            return $tabForm.is($form);
        }).each(function () {
            const control = bootstrap.Tab.getOrCreateInstance(this);

            if (control !== undefined && control !== null) {
                self.backgroundTabSwitch = true;

                control.show();
            }
        });
    }

    destroyListener() {
        this.teardownListeners();
        this.teardownElements();
    }

    teardownElements() {
        delete this.$idShotForm;
        delete this.$billingForm;
        delete this.$contactForm;
        delete this.$socialForm;

        delete this.$lastForm;
        delete this.$forms;

        delete this.$tabs;
        delete this.$tabControlContainer;
        delete this.$tabControls;
    }

    teardownListeners() {
        $(document).off('step:next', $.proxy(this.onStepNext, this));
        $(document).off('state:recalculate', $.proxy(this.onStateRecalculate, this));

        this.$forms.off('document_file_input:done', $.proxy(this.onDocumentFileInputDone, this));
        this.$lastForm.off('submit', $.proxy(this.onFinalSubmit, this));

        this.$element.off('document_file_input:file:click', $.proxy(this.onDocumentFileClick, this));

        this.$element.off('hidden.bs.tab', $.proxy(this.onTabHidden, this));
        this.$element.off('hide.bs.tab', $.proxy(this.onTabHide, this));
        this.$element.off('shown.bs.tab', $.proxy(this.onTabShown, this));

        $(window).off('beforeunload', $.proxy(this.onWindowBeforeUnload, this));
        $(document).off('visibilitychange', $.proxy(this.onDocumentVisibilityChange, this));
        $(document).off('content:loaded', $.proxy(this.onContentLoaded, this));
        $(document).off("user:interaction", $.proxy(this.onDocumentUserInteraction, this));
    }
}